import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { BUCKET_URL } from 'src/app/_shared/utils/constants';
import Swal from 'sweetalert2';
import { Service, ServiceCreateBody } from '../../interface';
import { ServicesService } from '../../services.service';
import { ServiceFormService } from './service-form.service';

@Injectable({
  providedIn: 'root'
})
export class ServiceDetailResolver implements Resolve<Service | ServiceCreateBody> {
  constructor(
    private service: ServicesService,
    private router: Router,
    private serviceFormService: ServiceFormService
  ) { }
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Service | ServiceCreateBody> {
    const id = route.paramMap.get('id');
    if (id === 'new') {
      this.serviceFormService.createForm()
      return of({
        name: "New Service",
        published: false,
        tags: [],
        region_scoping: [],
        packaging: [],
        category_id: '',
        country_id: '',
        default_package_id: 0,
        service_provider_id: '',
        unit_of_measure_id: '',
      })
    }
    return this.service.getService(route.params.id).pipe(
      tap(result => {
        this.serviceFormService.patchFormGroup(result)
      }),
      map(res => {
        return {
          ...res,
          icon: res.icon ? `${BUCKET_URL}${res.icon}` : 'https://via.placeholder.com/150?text=admin.ezyagric.com',
        };
      }),
      catchError(() => {
        Swal.fire({
          title: 'Error!',
          text: 'The service you are looking for does not exist.',
          type: 'error',
        })
        this.router.navigate(['/services']);
        return of(null);
      })
    );
  }

}
